var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"form-header"},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),_c('Hint',{staticClass:"form-header-hint",attrs:{"content":_vm.hint,"size":"regular"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }